var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-responsive',{class:[
    'image-cropper-container',
    {
      [_vm.cropperBgColor]: !!_vm.cropperBgColor,
      'image-cropper-container_defined-image': _vm.definedImage,
      'image-cropper-container_hidden-border-stencil': _vm.hiddenBorderStencil,
      'image-cropper-container_stencil-aspect-ratio_dinamic':
        _vm.stencilAspectRatioIsDinamic,
      'image-cropper-container_stencil-aspect-ratio_static':
        !_vm.stencilAspectRatioIsDinamic,
    },
  ],attrs:{"aspect-ratio":_vm.cropperAspectRatio}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }